/**
 * PitchBook Admin API
 * PitchBook Admin OpenAPI specification
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {createAction} from '@reduxjs/toolkit';
import {ApiMethods, ConcurrentStrategies} from '@pb/middleware-api';
import {PayloadData} from '../types';
import type {Error} from '../models/Error';
import type {UpdateAccessRequest} from '../models/UpdateAccessRequest';

export interface DisableAccessRights$Request {
    updateAccessRequest: UpdateAccessRequest;
}

export interface DisableAccessRights$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const disableAccessRightsRequest = createAction<PayloadData<void, DisableAccessRights$Request>>('ADMIN_BULK_UPDATE_ACCESS__DISABLE_ACCESS_RIGHTS__REQUEST');
export const disableAccessRightsSuccess = createAction<PayloadData<void, DisableAccessRights$Request>>('ADMIN_BULK_UPDATE_ACCESS__DISABLE_ACCESS_RIGHTS__SUCCESS');
export const disableAccessRightsFailure = createAction<PayloadData<Error, DisableAccessRights$Request, true>>('ADMIN_BULK_UPDATE_ACCESS__DISABLE_ACCESS_RIGHTS__FAILURE');

export const disableAccessRightsActions = [
    disableAccessRightsRequest,
    disableAccessRightsSuccess,
    disableAccessRightsFailure
] as const;

/**
 * @param {UpdateAccessRequest} meta.updateAccessRequest
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const disableAccessRights = (meta: DisableAccessRights$Request, config?: DisableAccessRights$Config) => {
    return {
        CALL_API: {
            types: disableAccessRightsActions,
            method: ApiMethods.POST,
            endpoint: `/web-api/admins/users/disable-access-rights`,
            TRANSPORT_REQUEST_BODY: meta.updateAccessRequest,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

export interface EnableAccessRights$Request {
    updateAccessRequest: UpdateAccessRequest;
}

export interface EnableAccessRights$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const enableAccessRightsRequest = createAction<PayloadData<void, EnableAccessRights$Request>>('ADMIN_BULK_UPDATE_ACCESS__ENABLE_ACCESS_RIGHTS__REQUEST');
export const enableAccessRightsSuccess = createAction<PayloadData<void, EnableAccessRights$Request>>('ADMIN_BULK_UPDATE_ACCESS__ENABLE_ACCESS_RIGHTS__SUCCESS');
export const enableAccessRightsFailure = createAction<PayloadData<Error, EnableAccessRights$Request, true>>('ADMIN_BULK_UPDATE_ACCESS__ENABLE_ACCESS_RIGHTS__FAILURE');

export const enableAccessRightsActions = [
    enableAccessRightsRequest,
    enableAccessRightsSuccess,
    enableAccessRightsFailure
] as const;

/**
 * @param {UpdateAccessRequest} meta.updateAccessRequest
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const enableAccessRights = (meta: EnableAccessRights$Request, config?: EnableAccessRights$Config) => {
    return {
        CALL_API: {
            types: enableAccessRightsActions,
            method: ApiMethods.POST,
            endpoint: `/web-api/admins/users/enable-access-rights`,
            TRANSPORT_REQUEST_BODY: meta.updateAccessRequest,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

